import axios from 'axios'
export default {
  name: 'index',
  components: {},
  data () {
    return {
      // 是否显示驾驶舱
      isShowJsc: null,
      // 文字显示
      isShowName: false,
      showSearch: true,
      // 卷宗档案和知网文献选择
      selectList: [{
        name: '烈士档案',
        id: 1
      }, {
        name: '研究文献',
        id: 0
      }],
      // 卷宗档案和知网文献选择id
      select: 1,
      // 搜索关键词输入
      keyword: '',
      // 下拉选中
      field: '',
      // 下拉列表
      fields: [
        {
          fieldname: '',
          displayname: ''
        }
      ],
      itemList1: [{
        name: '英烈档案',
        value: 'ylda'
      }, {
        name: '研究专题',
        value: 'yjzt'
      }, {
        name: '精品文物',
        value: 'jpww'
      }],
      itemList2: [{
        name: '著名专家',
        value: 'zmzj'
      }, {
        name: '机构成果',
        value: 'jgcg'
      }, {
        name: '红色动态',
        value: 'hsdt'
      }]
    }
  },
  // 创建元素
  mounted () {
    this.getmMultiple()
  },
  // 方法定义
  methods: {
    // 卷宗档案和知网文献选择
    handleSelect (item) {
      if (this.select !== item.id) {
        this.select = item.id
        this.getmMultiple()
      }
    },

    // 获取卷宗档案和知网文献的检索数组
    getmMultiple () {
      const self = this
      axios.get('/juanzong/retrieval/multiple/Publish', {
        params: {
          searchType: self.select
        }
      }).then(json => {
        if (json.data.status === '1') {
          this.fields = json.data.result.searchFields
          this.field = this.fields[0] ? this.fields[0].fieldname : ''
        }
        // else {
        //   self.$message.warning(json.data.message)
        // }
      }).catch(err => {
        console.log(err)
      })
    },

    // 搜索框的显示与隐藏
    isShowSearch (boolean) {
      this.showSearch = boolean
    },

    // 点击搜索
    handleSearch () {
      // eslint-disable-next-line no-unused-vars
      if (this.keyword.indexOf('<') !== -1 || this.keyword.indexOf('>') !== -1 || this.keyword.indexOf('\\') !== -1) {
        this.$message.warning('检索项不允许输入< > \\ 等特殊字符！')
        return
      }
      let displayname = ''
      this.fields.forEach(item => {
        if (item.fieldname === this.field) {
          displayname = item.displayname
        }
      })
      const keyword = encodeURIComponent(this.keyword)
      const url = `http://files.travel-yuhuatai.com:84/search?searchType=${this.select}&keyword=${keyword}&searchField=${this.field}&showSearchField=${displayname}&searchMethod=0`
      window.open(url, '_blank')
    },

    // 点击展开收起驾驶舱
    clickJsc () {
      this.isShowJsc = !this.isShowJsc
      if (this.isShowJsc) {
        setTimeout(() => {
          this.isShowName = true
        }, 1000)
      } else {
        this.isShowName = false
      }
    },

    // 点击驾驶舱下面的目录
    hangleJsc (param) {
      switch (param) {
        case 'cg':
          // eslint-disable-next-line no-case-declarations
          const cgUrl = 'http://files.travel-yuhuatai.com:82/data-bord'
          window.open(cgUrl, '_blank')
          break
        case 'yl':
          // eslint-disable-next-line no-case-declarations
          const ylUrl = 'http://files.travel-yuhuatai.com:84/data-bord'
          window.open(ylUrl, '_blank')
          break
        case 'academic':
          // eslint-disable-next-line no-case-declarations
          const academic = this.$router.resolve({ path: '/academic' })
          window.open(academic.href, '_blank')
          break
      }
    },

    // 点击门户各个系统
    handleItem (item) {
      switch (item.value) {
        // 英烈档案
        case 'ylda':
          // eslint-disable-next-line no-case-declarations
          const ylda = this.$router.resolve({ path: '/heroes' })
          window.open(ylda.href, '_blank')
          break
        // 研究专题
        case 'yjzt':
          // eslint-disable-next-line no-case-declarations
          const yjzt = this.$router.resolve({ path: '/yjzt' })
          window.open(yjzt.href, '_blank')
          break
        // 精品文物
        case 'jpww':
          // eslint-disable-next-line no-case-declarations
          const jpww = this.$router.resolve({ path: '/cultural' })
          window.open(jpww.href, '_blank')
          break
        // 著名专家
        case 'zmzj':
          // eslint-disable-next-line no-case-declarations
          const zmzj = this.$router.resolve({ path: '/famousExpert' })
          window.open(zmzj.href, '_blank')
          break
        // 机构成果
        case 'jgcg':
          // eslint-disable-next-line no-case-declarations
          const jgcg = this.$router.resolve({ path: '/results' })
          window.open(jgcg.href, '_blank')
          break
        case 'hsdt':
          // eslint-disable-next-line no-case-declarations
          const url = 'http://files.travel-yuhuatai.com:84/news'
          window.open(url, '_blank')
      }
    }
  }
}
